(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var body = drawer.querySelector('[data-cart-drawer-body]');
  var foot = drawer.querySelector('[data-cart-drawer-foot]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var progressFill = drawer.querySelector('[data-cart-progress]');
  var progressNote = drawer.querySelector('[data-cart-progress-note]');
  var threshold = parseInt(drawer.getAttribute('data-threshold') || '0', 10);
  var moneyFormat = drawer.getAttribute('data-money-format') || '€{{amount}}';
  var emptyText = drawer.getAttribute('data-empty') || 'Your bag is empty.';
  var progressLabel = drawer.getAttribute('data-progress-label') || '{amount} to free shipping';
  var progressFree = drawer.getAttribute('data-progress-free') || 'Complimentary shipping unlocked';

  var lastFocus = null;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    }
    return (cents / 100).toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function setProgress(total) {
    if (!progressFill || threshold <= 0) return;
    var p = Math.min(1, total / threshold);
    progressFill.style.setProperty('--p', p);
    if (progressNote) {
      var remaining = Math.max(0, threshold - total);
      progressNote.textContent = remaining > 0
        ? progressLabel.replace('{amount}', formatMoney(remaining))
        : progressFree;
    }
  }

  function refreshMarkup() {
    return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var incomingBody = tmp.querySelector('[data-cart-drawer-body]');
        var incomingFoot = tmp.querySelector('[data-cart-drawer-foot]');
        if (incomingBody && body) body.innerHTML = incomingBody.innerHTML;
        if (incomingFoot && foot) {
          foot.innerHTML = incomingFoot.innerHTML;
          if (incomingFoot.hasAttribute('hidden')) foot.setAttribute('hidden', '');
          else foot.removeAttribute('hidden');
        }
        subtotalEl = drawer.querySelector('[data-cart-subtotal]');
        progressFill = drawer.querySelector('[data-cart-progress]');
        progressNote = drawer.querySelector('[data-cart-progress-note]');
        bindLineControls();
      })
      .catch(function () {});
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-cart-open');
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var target = drawer.querySelector('.cart-drawer__close');
    if (target) setTimeout(function () { target.focus(); }, reduce.matches ? 0 : 280);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-cart-open');
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Open + close delegation
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      refreshMarkup().then(open);
      return;
    }
    var closeBtn = e.target.closest('[data-cart-drawer-close]');
    if (closeBtn && drawer.contains(closeBtn)) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
      var focusables = drawer.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  // ---- line controls ----
  function bindLineControls() {
    drawer.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-cart-qty-input]');
      var dec = line.querySelector('[data-cart-qty="decrease"]');
      var inc = line.querySelector('[data-cart-qty="increase"]');
      var rm = line.querySelector('[data-cart-remove]');

      function changeTo(qty) {
        line.style.opacity = '0.55';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            setProgress(cart.total_price);
            if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
            return refreshMarkup();
          })
          .catch(function () { line.style.opacity = '1'; });
      }
      if (dec) dec.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        changeTo(Math.max(0, val - 1));
      });
      if (inc) inc.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 0;
        changeTo(val + 1);
      });
      if (input) input.addEventListener('change', function () {
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        changeTo(val);
      });
      if (rm) rm.addEventListener('click', function () { changeTo(0); });
    });
  }
  bindLineControls();

  // ---- PDP form + quick-add interception ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-pdp-error]');
    if (errorEl) errorEl.textContent = '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCount(cart.item_count);
      return refreshMarkup();
    }).then(open)
      .catch(function (err) {
        if (errorEl) errorEl.textContent = (err && err.description) || 'Sorry, we could not add that to your bag.';
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); }
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart.item_count); return refreshMarkup(); })
      .then(open)
      .catch(function () {})
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();
